import { Skeletons } from '~/shared/components/Skeletons';
import { ListLoadingSkeletonProps } from '~/shared/types/ListLoadingSkeleton';

import { Card } from '../Card';

export function ListLoadingSkeleton({
  hideCardStructure = false
}: ListLoadingSkeletonProps) {
  if (hideCardStructure) {
    return (
      <div className="flex flex-col items-start gap-6">
        <Skeletons height={43} width="35%" />
        <Skeletons height={43} width="40%" />
        <Skeletons height={33} width="20%" />
        <Skeletons height={54} width="10%" />
      </div>
    );
  }

  return (
    <Card.Root>
      <Card.Header>
        <div className="flex flex-col gap-1">
          <Skeletons height={22} width="25%" />
          <Skeletons height={22} width="20%" />
        </div>
      </Card.Header>

      <Card.Content>
        <div className="flex flex-col items-start gap-6">
          <Skeletons height={43} width="35%" />
          <Skeletons height={43} width="40%" />
          <Skeletons height={33} width="20%" />
          <Skeletons height={54} width="10%" />
        </div>
      </Card.Content>

      <Card.Footer>
        <div className="flex justify-center items-center">
          <Skeletons height={40} width="25%" />
        </div>
      </Card.Footer>
    </Card.Root>
  );
}
